import { useCallback, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import MediaService from '../../services/MediaService';
import UnitNavigation from '../../components/Navigation/UnitNavigation';
import Surprise from '../../components/World/Surprise/Surprise';
import { GetUserVideo, getVideo } from '../../s3Func/s3Download';

const Module11Nav = () => {
  const { module11 } = useSelector((state) => state.module11, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  /*****************
   *  BG Image Logic
   * ***************/

  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseConfig, setSurpriseConfig] = useState(null);
  const bgImage = useRef();

  const checkScreenSize = () => {
    const desktopImage =
      '/Module11Images/JourneyMap.png';
    const mobileImage =
      '/Module11Images/Background_JourneyMap_Underwater.png';

    bgImage.current =
      window.screen && window.screen.width < 1025 ? mobileImage : desktopImage;
  };

  const resizeListener = useCallback(() => {
    window.addEventListener(
      'resize',
      (event) => checkScreenSize(event.target),
      true
    );
  }, []);

  resizeListener();
  checkScreenSize();

  const backgroundPath =
    bgImage.current && MediaService.getImage(bgImage.current, login);
  const worldBG = MediaService.getImage(
    '/Module11Images/Unit3_Mod1_Background-1.png',
    login
  );

  /*****************
   *  Day Logic
   * ***************/

  const getDayConfig = useCallback((dayNumber) => {
    const filledImageUrl = `/Module6Images/Module6NavImages/Underwater_journeymap_Day${dayNumber}.png`;
    const outlinedImageUrl = `/Module6Images/Module6NavImages/Underwater_journeymap_Day${dayNumber}_1.png`;

    return {
      dayNumber,
      destiny: '/feelings',
      filledImageUrl,
      outlinedImageUrl,
    };
  }, []);

  const daysArray = [...Array(8).keys()];
  const DAYS_CONFIG = daysArray.map((index) => getDayConfig(index + 1));

  const SURPRISE_VIDEO = {
    song: 'appfiles/feelings/feelings_instrumental.m4a',
    slides: [
      `influencers/${login.influencerid}/greet_affirmation.mp4`,
      `userfiles/${module11.StudentID}/feelings_celebration_surprise_5.mp4`,
      `influencers/${login.influencerid1}/greet_affirmation.mp4`,
      `userfiles/${module11.StudentID}/feelings_celebration_surprise_8.mp4`,
      `influencers/${login.influencerid2}/greet_video_message.mp4`,
      `influencers/${login.influencerid3}/greet_affirmation.mp4`,
      `userfiles/${module11.StudentID}/feelings_celebration_surprise_9.mp4`,
      `influencers/${login.influencerid4}/greet_affirmation.mp4`
    ],
  };

  const handleSurpriseClick = async () => {
    let { slides, song, video } = SURPRISE_VIDEO;

    slides = await Promise.all(
      slides.map(async (url) => await GetUserVideo(url, login))
    );
    song = await getVideo(song, login);

    setSurpriseConfig({ video, slides, song });
    setDisplaySurprise(true);
  };

  /*****************************
   *  Component configuration
   * ***************************/

  return (
    <>
      {displaySurprise && (
        <Surprise
          background={worldBG}
          setDisplaySurprise={setDisplaySurprise}
          video={surpriseConfig.video}
          song={surpriseConfig.song}
          slides={surpriseConfig.slides}
          onSurpriseEnded={() => setDisplaySurprise(false)}
        />
      )}

      {backgroundPath && (
        <UnitNavigation
          moduleName='MODULE11'
          module={module11}
          days={DAYS_CONFIG}
          totalDays={8}
          unitDestiny='/unit3'
          nextDestiny='/unit3'
          backgroundPath={backgroundPath}
          onSurpriseClick={handleSurpriseClick}
          unit={3}
          animal={MediaService.getImage('/Images/Button_CrabHead.png', login)}
        />
      )}
    </>
  );
};
export default Module11Nav;
